/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransitionDatabaseRequest
 */
export interface TransitionDatabaseRequest {
    /**
     * 
     * @type {string}
     * @memberof TransitionDatabaseRequest
     */
    email?: string;
}

/**
 * Check if a given object implements the TransitionDatabaseRequest interface.
 */
export function instanceOfTransitionDatabaseRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TransitionDatabaseRequestFromJSON(json: any): TransitionDatabaseRequest {
    return TransitionDatabaseRequestFromJSONTyped(json, false);
}

export function TransitionDatabaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransitionDatabaseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function TransitionDatabaseRequestToJSON(value?: TransitionDatabaseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

